export const types = {
  BANK_ID_REQUEST: 'moank/auth/BANK_ID_REQUEST',
  BANK_ID_SUCCESS: 'moank/auth/BANK_ID_SUCCESS',
  BANK_ID_FAILURE: 'moank/auth/BANK_ID_FAILURE',
  STORE_BANK_ID_INSTRUCTIONS: 'moank/auth/STORE_BANK_ID_INSTRUCTIONS',
  LOGIN_REQUEST: 'moank/auth/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'moank/auth/LOGIN_SUCCESS',
  LOGIN_FAILURE: 'moank/auth/LOGIN_FAILURE',
  LOGOUT: 'moank/auth/LOGOUT',
  SELECT_BANK_ID_TYPE: 'moank/auth/SELECT_BANK_ID_TYPE',
  START_BANK_ID_TIMEOUT: 'moank/auth/START_BANK_ID_TIMEOUT',
  SET_BANK_ID_TIMEOUT: 'moank/auth/SET_BANK_ID_TIMEOUT',
};

export const bankId = () => ({ type: types.BANK_ID_REQUEST });
export const bankIdSuccess = (payload) => ({ type: types.BANK_ID_SUCCESS, payload });
export const bankIdFailure = () => ({ type: types.BANK_ID_FAILURE });
export const storeBankIdInstructions = (payload) => ({
  type: types.STORE_BANK_ID_INSTRUCTIONS,
  payload,
});
export const login = (payload) => ({ type: types.LOGIN_REQUEST, payload });
export const loginSuccess = () => ({ type: types.LOGIN_SUCCESS });
export const loginFailure = () => ({ type: types.LOGIN_FAILURE });
export const logout = () => ({ type: types.LOGOUT });
export const selectBankIdType = (bankIdType) => ({
  type: types.SELECT_BANK_ID_TYPE,
  payload: { bankIdType },
});
export const startBankIdTimeout = () => ({ type: types.START_BANK_ID_TIMEOUT });
export const setBankIdTimeout = (endTime) => ({
  type: types.SET_BANK_ID_TIMEOUT,
  payload: { endTime },
});
